'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('data', {
      url: '/account/data',
      template: '<data></data>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/data/data.routes.js